import React from 'react';
import { Link } from 'react-router-dom';
import { SegmentData, VehicleInformation, Hero } from './MotorcycleView';
import Grid from '@material-ui/core/Grid';
import { withNamespaces, WithNamespaces } from 'react-i18next';
import { withStyles, WithStyles, Theme } from '@material-ui/core/styles';
import Format from '../../../utils/formatter';

export interface ModelsProps {
	data: SegmentData;
}

const classes = (theme: Theme) => ({
	modelLink: {
		fontSize: '14px',
		lineHeight: '22px',
	},
	spacer: {
		marginBottom: '24px',
	},
	selectionWrapper: {
		padding: '20px 0 0 20px',
		overflowY: 'auto' as "auto",
	},
	modelSelectionWrapper: {
		height: 'calc(100% - 75px)',
	},
	previewWrapper: {
		paddingTop: 40,
	},
	VehicleInformation: {
		backgroundRepeat: 'no-repeat',
	},
	bikePreview: {
		backgroundPosition: 'right top',
		backgroundSize: 'auto 93%',
	},
	previewBoxWrapper: {
		borderLeft: '1px solid #eee',
	},
	heroTitle: {
		fontSize: '3.75em',
		lineHeight: '1em',
	},
	heroIntro: {
		fontSize: '1.25em',
	},
	heroPrice: {
		fontSize: '1.25em',
	},
	heroDescription: {
		fontSize: '1em',
	},
});

export type AllModelProps = ModelsProps & WithNamespaces & WithStyles;

export interface ModelsState {
	Hero: Hero;
	isDefault: boolean;
}
export class Models extends React.Component<AllModelProps, ModelsState>  {
	constructor(props: AllModelProps) {
		super(props);
		this.selectHero = this.selectHero.bind(this);
		this.sortModels = this.sortModels.bind(this);

		const { Hero } = this.props.data;
		this.state = { Hero, isDefault: true };
	}

	selectHero(Hero: Hero, isDefault: boolean) {
		this.setState({ Hero, isDefault });
	}

	componentDidUpdate(oldProps: ModelsProps) {
		const newProps = this.props
		if (oldProps.data !== newProps.data) {
			this.setState({ Hero: newProps.data.Hero, isDefault: true })
		}
	}

	extract(str: string): { engineSize: number, name: string, year: number } {
		const spacedModelName = str.replace(/\s/g, ' ');

		// if detection pattern fails,
		// provide default to let model sink to the bottom of list
		if (spacedModelName.split(' ').length < 3) {
			return {
				engineSize: 0,
				name: '',
				year: 0,
			}
		}

		const firstSpace = spacedModelName.indexOf(' ');
		const lastSpace = spacedModelName.lastIndexOf(' ');

		return {
			engineSize: +spacedModelName.slice(0, firstSpace) || 0,
			name: spacedModelName.slice(firstSpace + 1, lastSpace),
			year: +spacedModelName.slice(lastSpace + 1, spacedModelName.length) || 0,
		};
	};

	sortModels(prev: VehicleInformation, next: VehicleInformation) {
		const [extractedPrevious, extractedNext] = [this.extract(prev.Name), this.extract(next.Name)];
		return (-(extractedPrevious.engineSize - extractedNext.engineSize) ||
			extractedPrevious.name.toLocaleLowerCase().localeCompare(extractedNext.name.toLocaleLowerCase()) ||
			-(extractedPrevious.year - extractedNext.year));
	}

	render() {
		const { Vehicles } = this.props.data;
		const {
			modelLink,
			spacer,
			selectionWrapper,
			modelSelectionWrapper,
			previewWrapper,
			VehicleInformation,
			bikePreview,
			previewBoxWrapper,
			heroTitle,
			heroIntro,
			heroPrice,
			heroDescription,
		} = this.props.classes;
		const { isDefault } = this.state;
		const backgroundImage = `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${process.env.REACT_APP_SERVER_ROOT}${this.state.Hero.ImageUrl})`;
		const defaultPreviewStyles = {
			color: 'white',
			backgroundImage,
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			paddingLeft: 40,
			height: '100%',
		};

		const selectedPreviewStyles = {
			color: 'black',
			backgroundImage: `url(${process.env.REACT_APP_SERVER_ROOT}${this.state.Hero.ImageUrl})`,
		};
		const { Intro, Title, Price, Description } = this.state.Hero;

		const engineTypes: Array<string | null> = Vehicles.reduce((acc: Array<string | null>, vehicle: VehicleInformation) => {
			return acc.includes(vehicle.EngineType) ? [...acc] : [...acc, vehicle.EngineType];
		}, []);

		return (
			<Grid className={modelSelectionWrapper} container spacing={0}>
				{/* MODEL SELECTION PART */}
				<Grid id="model-selection-choice" className={`full-height ${selectionWrapper}`} item xs={4}>
					<Grid container>
						{engineTypes.map((version: string | null, index: number) => {
							const filtered = Vehicles
								.filter((item: VehicleInformation) => item.EngineType === version)
								.sort(this.sortModels);
							if (!filtered.length) {
								return null;
							}
							return (
								<Grid xs={6} item key={`by-tact-${index}`}>
									{version !== null && <h2 className={spacer} >{version}</h2>}
									<ul>
										{filtered.map((item: VehicleInformation, index: number) => (
											<li key={index}>
												<Link
													onMouseEnter={this.selectHero.bind(null, item.Hero, false)}
													onMouseLeave={this.selectHero.bind(null, this.props.data.Hero, true)}
													className={`ktm-underlined clickable black thin text inline-block ${modelLink} ${spacer}`}
													to={{ pathname: `/main/overview/${item.ModelId}`, state: { hero: item.Hero } }}>
													{item.Name}
												</Link>
											</li>)
										)}
									</ul>
								</Grid>
							)
						})}
					</Grid>
				</Grid>
				{/* PREVIEW PART */}
				<Grid id="model-selection-preview" className={`full-height ${previewBoxWrapper}`} item xs={8}>
					{isDefault &&
						<div style={defaultPreviewStyles}>
							<div className={previewWrapper}>
								<h5 className={heroIntro}>{Intro}</h5>
								<h2 className={heroTitle}>{Title}</h2>
							</div>
						</div>}
					{!isDefault &&
						<div className="full-height" style={{ color: 'black' }}>
							<Grid container className={`full-height ${previewWrapper}`}>
								<Grid className={`${VehicleInformation} ${bikePreview}`} item xs={6} style={selectedPreviewStyles}></Grid>
								<Grid item xs={6}>
									<h5 className={heroIntro}>{Intro}</h5>
									<h2 className={heroTitle}>{Title}</h2>
									<p className={heroPrice}><strong>{Format.currency(Price)}</strong></p>
									<p className={heroDescription}>{Description}</p>
								</Grid>
							</Grid>
						</div>}
				</Grid>
			</Grid >
		);
	}
}

export default withStyles(classes)(withNamespaces()(Models));
